import noop from 'lib/function/noop'
import React from 'react'

type UserAnalyticsAction = (action: string, label?: string) => void

const UserAnalyticsActionContext = React.createContext<UserAnalyticsAction>(noop)

export default UserAnalyticsActionContext
